module.exports = __webpack_public_path__ + "img/icone-implemento.6ad55b98.svg";